import { parsePhoneNumberWithError } from "libphonenumber-js";
import { addMethod, StringSchema, string as yupString } from "yup";

import { PhonenumberPrefix } from "@/redux/modules/api/data/phonenumberPrefixes/phonenumberPrefixes.types";
import { Translate } from "@/redux/modules/value/translations/translations.provider";

import { string } from "./general.RHF";

type PhoneContext = {
    phonenumberPrefixData: Array<PhonenumberPrefix>;
};

addMethod<StringSchema<string, PhoneContext>>(
    yupString,
    "phoneRHF",
    function (required) {
        return this.test("phone", (value, {
            createError,
            parent,
            path,
            options: {
                context: { phonenumberPrefixData: prefixData = [] } = {}
            }
        }) => {
            if (!required && !value) return true;

            const prefix = parent[`${path}Prefix`];
            const iso = prefixData.find((d) => d.prefix === prefix);

            let newPhone;
            try {
                newPhone = parsePhoneNumberWithError(
                    `${value!}`,
                    iso?.country.isoCode
                );
            } catch (_) {
                return createError({
                    message: () => () => (t: Translate) =>
                        t("general.form.input.validation.phone.invalid")
                });
            }

            return (
                newPhone?.isValid() ||
                createError({
                    message: () => () => (t: Translate) =>
                        t("general.form.input.validation.phone.invalid")
                })
            );
        });
    }
);

export const phone = string().nullable().required().phoneRHF(true);

export const optionalPhone = string().nullable().phoneRHF(false);

export const phonePrefix = string().nullable().required();
